/* eslint-disable */
import _ from 'underscore';
function Collaborator(definitions) {
  this.definitions = definitions || ({});
  this.instances = {};
}
Collaborator.prototype.role = function (name, options) {
  if (typeof options === 'undefined' && this.instances[name]) {
    return this.instances[name];
  }
  var definition = this.definitions[name];
  if (!definition) {
    throw new Error('Role "' + name + '" is not defined.');
  }
  var factory = definition.factory;
  if (!factory) {
    throw new Error('Role "' + name + '" does not have a factory.');
  }
  this.instances[name] && factory.release && factory.release(this.instances[name]);
  this.instances[name] = null;
  var instance = factory.create(options);
  _.each(definition.events, function (handler, eventName) {
    factory.bindEvent(name, instance, eventName, handler);
  });
  definition.extend && _.extend(instance, definition.extend);
  this.instances[name] = instance;
  return instance;
};
Collaborator.prototype.clear = function (options) {
  var opt = _.defaults({}, options, {
    filter: function () {
      return true;
    }
  });
  _.each(this.instances, (function (instance, name) {
    if (instance && opt.filter(name, instance)) {
      this.definitions[name].factory.release(instance);
      this.instances[name] = null;
    }
  }).bind(this));
};
Collaborator.factory = function (Type, strategy, defaults) {
  return {
    create: function (options) {
      var opt = _.defaults({}, options, defaults, strategy.defaults);
      var instance = new Type(opt);
      strategy.extend && _.extend(instance, strategy.extend);
      strategy.initialize && strategy.initialize.call(instance);
      return instance;
    },
    release: function (instance) {
      strategy.destroy && strategy.destroy.call(instance);
    },
    bindEvent: strategy.bindEvent || (function (roleName, instance, eventName, handler) {
      instance.on(eventName, handler);
    })
  };
};
export default Collaborator;

